import React, { FC } from 'react';
import { ADMIN_ROUTES } from 'constants/routes';
import { CloseOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Button, Col, Drawer, Row, Typography } from 'components';

const { Text } = Typography;

interface IClientsDrawer {
  onExpand: () => void;
  drawerState: boolean;
  data?: Record<string, any>[];
}

export const ClientsDrawer: FC<IClientsDrawer> = React.memo((props) => {
  const { onExpand, drawerState, data } = props;
  return (
    <Drawer
      closeIcon={null}
      placement="left"
      width={471}
      open={drawerState}
      onClose={() => onExpand()}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      title={'Clients'}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={() => onExpand()} type="text" />
      </div>
      <Row>
        {data?.map((client) => (
          <Col key={client.id} span={24} className={'padding-8'}>
            <Link to={`${ADMIN_ROUTES.clients}/${client.id}/general`} target={'_blank'}>
              <Text type={'secondary'} underline>
                {client.name}
              </Text>
            </Link>
          </Col>
        ))}
      </Row>
    </Drawer>
  );
});
